module.exports = __webpack_public_path__ + "static/media/color-section-6.bab8bdbc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/features/assets/color-section-6.svg
// module id = 118
// module chunks = 0